import { render, staticRenderFns } from "./StudyDrawer.vue?vue&type=template&id=158f24fe"
import script from "./StudyDrawer.vue?vue&type=script&lang=js"
export * from "./StudyDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports